// StepItem.jsx
export default function StepItem({
  name,
  stepNumber,
  step,
  setStep,
}) {
  const active = step >= stepNumber;

  return (
    <div
      onClick={() => setStep(stepNumber)}
      className="relative z-10 flex flex-col items-center cursor-pointer flex-1"
    >
      {/* CIRCLE */}
      <div
        className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center
        text-white font-semibold text-xs sm:text-sm transition-all duration-300
        ${
          active
            ? "bg-blue-600"
            : "bg-gray-300"
        }`}
      >
        {stepNumber}
      </div>

      {/* LABEL */}
      <p
        className={`mt-2 w-20 sm:w-28 text-[10px] sm:text-xs md:text-sm font-medium text-center leading-tight
        ${
          active
            ? "text-blue-700"
            : "text-gray-500"
        }`}
      >
        {name}
      </p>
    </div>
  );
}